import { createReducer } from '@reduxjs/toolkit';
import { videoInit } from 'redux/reducers/init';
import {
  changeVideoCurrentTime,
  changeVideoDuration,
  changeVideoInTime,
  changeVideoOutTime,
  initVideo,
} from 'redux/actions/actions';
import { VideoState } from './type';
import { VideoAction } from 'redux/actions/type';
import TimeCode from 'commons/utils/TimeCode';

const video = createReducer(videoInit, {
  [initVideo.type]: (state: VideoState, action: VideoAction) => {
    const { fps } = action.payload;
    state.fps = fps;
  },
  [changeVideoInTime.type]: (state: VideoState, action: VideoAction) => {
    const { inTime } = action.payload;
    state.inTime = inTime;
  },
  [changeVideoOutTime.type]: (state: VideoState, action: VideoAction) => {
    const { outTime } = action.payload;
    state.outTime = outTime;
  },
  [changeVideoDuration.type]: (state: VideoState, action: VideoAction) => {
    const { duration } = action.payload;
    state.duration = duration;
  },
  [changeVideoCurrentTime.type]: (state: VideoState, action: VideoAction) => {
    const { currentTime } = action.payload;
    state.currentTime = currentTime;
  },
});

export default video;
